export const createSentimentTooltip = (timePeriodName) => (averageSentiment, currentSentiment) => {
    const sentimentIncrease = currentSentiment - averageSentiment;
    const sentimentChange = Math.abs(sentimentIncrease).toFixed(1);
    if (sentimentChange === "0.0") {
        return `Current sentiment is the same as the ${timePeriodName} at ${averageSentiment.toFixed(1)}%.`;
    }
    const direction = currentSentiment > averageSentiment ? "longer" : "shorter";
    return `${sentimentChange} percentage points ${direction} than the ${timePeriodName}.\nAverage ${averageSentiment.toFixed(1)}%. Currently ${currentSentiment.toFixed(1)}%.`
};

export const createVolumeTooltip = (timePeriodName) => (averageVolume, currentVolume) => {
    const volumeIncrease = 100 * (currentVolume - averageVolume) / averageVolume;
    const volumeChange = Math.abs(volumeIncrease).toFixed(1);
    if (volumeChange === "0.0") {
        return `Current volume share is the same as the ${timePeriodName} at ${averageVolume.toFixed(1)}%.`;
    }
    const direction = currentVolume > averageVolume ? "higher" : "lower";
    return `A ${volumeChange} percent ${direction} share of volume than the ${timePeriodName}.\nAverage ${averageVolume.toFixed(1)}%. Currently ${currentVolume.toFixed(1)}%.`
};